import React, { useState } from 'react';
import styled from 'styled-components';
import { Text, Icon } from '../';
import { colors } from '../../../stylesheets';

const StyledCheckBox = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 8px;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  background-color: ${(props) =>
    props.disabled ? colors['lighterGray'] : colors['white']};
  border: 1px solid
    ${(props) =>
      props.checked && !props.disabled
        ? colors['primary']
        : colors['lightGray']};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledInnerCheckBox = styled.div`
  background-color: ${(props) =>
    props.disabled ? colors['lightGray'] : colors['primary']};
  width: 100%;
  height: 100%;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

type Props = {
  checked?: boolean,
  onChange: Function,
  title: string,
  disabled: boolean,
  className: string,
};

CheckBox.defaultProps = {
  checked: false,
  disabled: false,
  className: '',
};

export default function CheckBox(props: Props) {
  const { checked, onChange, title, disabled, className } = props;
  const handleChange = () => {
    // if (!props.disabled) setChecked(!checked);
    onChange(!checked);
  };

  return (
    <div className={`d-flex flex-row align-items-center ${className}`}>
      <StyledCheckBox
        checked={checked}
        className="ml-2"
        onClick={handleChange}
        disabled={disabled}
      >
        {checked ? (
          <StyledInnerCheckBox disabled={disabled}>
            <Icon name="d-check" />
          </StyledInnerCheckBox>
        ) : null}
      </StyledCheckBox>
      <Text onClick={handleChange} size="md" color="blackText">
        {title}
      </Text>
    </div>
  );
}
